<template>
    <select class="form-control" name="template_id" id="template_id" @change="onChange($event)">
    	<option value=''>Selecciona un template</option>
		<option v-for="template in options" :key="template.id" :value="template.id" :selected="parseInt(selectedValue) == template.id" >{{ template.name }} ({{ template.description }})</option>
	</select>
</template>

<script>
	import axios from 'axios';

    export default {
        name: 'template-selector',
        props: {
        	selectedValue : {
				type: String
			}
        },
        data () {
			return {
				value : '',
				options : [],
			};
		},
		methods: {
			onChange(event) {
				let optionSelected = event.target.value;
				let templateId;
				if (optionSelected) {
					for (let key in this.options) {
						if (key == optionSelected - 1) {
							templateId = this.options[key]['id'];
						}
					}
				}
				this.value = templateId;
				this.$emit('update', templateId);
			},
			initTemplates () {
				axios
					.get('https://res.hotelkey.com/reservas/mvc.php/product_decision_scr_templates_web_json/ScrTemplates/list')
					.then(response => {
						if (response.data.result) {
							this.options = response.data.data
						} else {
							this.emitError();
						}
					}).catch(error => {
						this.emitError();
					})
			},
			emitError () {
				this.$emit('error', "Se ha producido un error al consultar los templates.");
			}
		},
		created () {
			this.initTemplates ();
		}
    }
</script>